// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  background-color: white;
  color: #696969;
  font-family: "Quicksand", serif;
  font-weight: 500;
  width: 100%;
}

.App-logo-container {
  width: 250px;
  height: 250px;
  margin-left: 50px;
}

.header-title {
  font-family: "Lily Script One", cursive;
  color: #7faedc;
  font-size: 48px;
  @media screen and (max-width: 1000px) {
    font-size: 30pt;
  }
}

.bb-logo {
  width: 100%;
  height: 100%;
}

.App-nav {
  width: 100%;
  height: 170px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: calc(10px + 2vmin);
  padding: 0 5%;

  @media screen and (max-width: 500px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
}

.App-nav-links {
  width: 50%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;

  @media screen and (max-width: 500px) {
    white-space: nowrap;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    align-content: center;
  }

  @media screen and (max-width: 900px) {
    width: 80%;
  }
}

.App-nav-link {
  color: #7faedc;
  text-decoration: none;
  text-transform: uppercase;
  font-size: 16pt;
  cursor: pointer;
  font-weight: bold;

  @media screen and (max-width: 500px) {
    font-size: 10pt;
    white-space: nowrap;
  }

  @media screen and (max-width: 1000px) {
    font-size: 13pt;
    white-space: nowrap;
  }
}
.App-nav-link:hover {
  cursor: pointer;
  text-decoration: none;
}

.App-nav-link-decoration {
  color: #7faedc;
  text-decoration: none;
  text-transform: uppercase;
  font-size: 12pt;
  font-weight: bold;
  padding: 1vw;

  @media screen and (max-width: 500px) {
    font-size: 8pt;
  }
}

.header-image-container {
  width: 100%;
  height: 700px;
  margin-top: 20px;

  @media screen and (max-width: 500px) {
    height: 300px;
  }
}

.header-image {
  width: 100%;
  height: 100%;
}

.section-container {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.App-divider {
  border-bottom-width: 4px;
  border-bottom-color: #7faedc;
  border-style: none none double none;
  width: 90%;
  margin-left: 5%;
}

.App-footer {
  height: 150px;
  width: 100%;
  border-top: 4px double #7faedc;
  margin-top: 40px;
  background-color: #7faedc;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,+BAA+B;EAC/B,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,uCAAuC;EACvC,cAAc;EACd,eAAe;EACf;IACE,eAAe;EACjB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,6BAA6B;EAC7B,aAAa;;EAEb;IACE,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;EACb;AACF;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;;EAEnB;IACE,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,iBAAiB;;EAEjB;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;AACA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,YAAY;;EAEZ;IACE,cAAc;EAChB;AACF;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;;EAEhB;IACE,aAAa;EACf;AACF;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,mCAAmC;EACnC,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,gBAAgB;EAChB,yBAAyB;AAC3B","sourcesContent":[".App {\n  text-align: center;\n  background-color: white;\n  color: #696969;\n  font-family: \"Quicksand\", serif;\n  font-weight: 500;\n  width: 100%;\n}\n\n.App-logo-container {\n  width: 250px;\n  height: 250px;\n  margin-left: 50px;\n}\n\n.header-title {\n  font-family: \"Lily Script One\", cursive;\n  color: #7faedc;\n  font-size: 48px;\n  @media screen and (max-width: 1000px) {\n    font-size: 30pt;\n  }\n}\n\n.bb-logo {\n  width: 100%;\n  height: 100%;\n}\n\n.App-nav {\n  width: 100%;\n  height: 170px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  font-size: calc(10px + 2vmin);\n  padding: 0 5%;\n\n  @media screen and (max-width: 500px) {\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n  }\n}\n\n.App-nav-links {\n  width: 50%;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n  align-items: center;\n\n  @media screen and (max-width: 500px) {\n    white-space: nowrap;\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-around;\n    align-items: center;\n    align-content: center;\n  }\n\n  @media screen and (max-width: 900px) {\n    width: 80%;\n  }\n}\n\n.App-nav-link {\n  color: #7faedc;\n  text-decoration: none;\n  text-transform: uppercase;\n  font-size: 16pt;\n  cursor: pointer;\n  font-weight: bold;\n\n  @media screen and (max-width: 500px) {\n    font-size: 10pt;\n    white-space: nowrap;\n  }\n\n  @media screen and (max-width: 1000px) {\n    font-size: 13pt;\n    white-space: nowrap;\n  }\n}\n.App-nav-link:hover {\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.App-nav-link-decoration {\n  color: #7faedc;\n  text-decoration: none;\n  text-transform: uppercase;\n  font-size: 12pt;\n  font-weight: bold;\n  padding: 1vw;\n\n  @media screen and (max-width: 500px) {\n    font-size: 8pt;\n  }\n}\n\n.header-image-container {\n  width: 100%;\n  height: 700px;\n  margin-top: 20px;\n\n  @media screen and (max-width: 500px) {\n    height: 300px;\n  }\n}\n\n.header-image {\n  width: 100%;\n  height: 100%;\n}\n\n.section-container {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n}\n\n.App-divider {\n  border-bottom-width: 4px;\n  border-bottom-color: #7faedc;\n  border-style: none none double none;\n  width: 90%;\n  margin-left: 5%;\n}\n\n.App-footer {\n  height: 150px;\n  width: 100%;\n  border-top: 4px double #7faedc;\n  margin-top: 40px;\n  background-color: #7faedc;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
